import { render, staticRenderFns } from "./Profesional.vue?vue&type=template&id=43fc17f8&scoped=true"
import script from "./Profesional.vue?vue&type=script&lang=js"
export * from "./Profesional.vue?vue&type=script&lang=js"
import style0 from "./Profesional.vue?vue&type=style&index=0&id=43fc17f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fc17f8",
  null
  
)

export default component.exports